const expenseCategory = {
  path: '/expenseCategory',
  name: 'expenseCategory',
  component: () =>
    import(
      /* webpackChunkName: "expense_category" */ '@/components/expenseCategory/ExpenseCategoryIndex.vue'
    ),
  children: [
    {
      path: 'view/:id',
      component: () =>
        import(
          /* webpackChunkName: "expense_category" */ '@/components/expenseCategory/ExpenseCategoryView.vue'
        ),
      name: 'expenseCategoryView',
    },
    {
      path: 'edit/:id',
      component: () =>
        import(
          /* webpackChunkName: "expense_category" */ '@/components/expenseCategory/ExpenseCategoryEdit.vue'
        ),
      name: 'expenseCategoryEdit',
    },
    {
      path: 'create',
      component: () =>
        import(
          /* webpackChunkName: "expense_category" */ '@/components/expenseCategory/ExpenseCategoryCreate.vue'
        ),
      name: 'expenseCategoryCreate',
    },
  ],
  meta: { authorize: [], requiresAuth: true },
};

export default expenseCategory;
